import { parseDescription, type DescriptionRun } from "@/lib/formatted-description";

function inline(runs: DescriptionRun[]) {
  return runs.map((run, index) => {
    const text = run.italic ? <em>{run.text}</em> : run.text;
    return run.bold ? <strong key={index}>{text}</strong> : <span key={index}>{text}</span>;
  });
}

export function FormattedDescription({ text }: { text: string }) {
  return <div className="break-words text-xs leading-relaxed text-gray-700">
    {parseDescription(text).map((block, index) => {
      if (block.type === "blank") return <div key={index} className="h-3" aria-hidden="true" />;
      if (block.type === "list") {
        const items = block.items.map((runs, item) => <li key={item}>{inline(runs)}</li>);
        return block.ordered
          ? <ol key={index} start={block.start} className="list-decimal space-y-1 pl-5">{items}</ol>
          : <ul key={index} className="list-disc space-y-1 pl-5">{items}</ul>;
      }
      return block.type === "heading"
        ? <div key={index} role="heading" aria-level={block.level}
            className={`mb-1 mt-2 font-bold ${block.level <= 2 ? "text-base" : "text-sm"}`}>{inline(block.runs)}</div>
        : <p key={index} className="whitespace-pre-wrap">{inline(block.runs)}</p>;
    })}
  </div>;
}
